import "@fullcalendar/common/main.css";
import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import markup from "ulysses/widgets/calendar.html";
import moment from "moment";
import { Calendar } from "@fullcalendar/core";
import daygridPlugin from "@fullcalendar/daygrid";
import timegridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import bootstrapPlugin from '@fullcalendar/bootstrap';
import interactionPlugin, {ThirdPartyDraggable} from '@fullcalendar/interaction';
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import { fetch_item_actions } from "ulysses/widgets/search/search_item";
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import dragula from "dragula";

function remove_event_by_id(ev) {
}

function render_event_text(event) {
    var tmp = "";
    if (event.start != null) tmp += event.start.format("LT");
    if (event.end != null) tmp += " - " + event.end.format("LT");
    return tmp;
}

function event_click_drop_resize_callback(calEvent, jsEvent, view) {
    var source = calEvent.source;
    delete(calEvent.source);
    calEvent["date"] = new Date(calEvent.start.getTime());
    calEvent["date"].setHours(0);
    calEvent["date"].setMinutes(0);
    calEvent["date"].setSeconds(0);
    //edit special data
    /*
        Crimson.dialogs.set_special_day_interval(calEvent).done(function(result){
        if ($.abort){
        $.abort = false
        return false;
        }
        Crimson.server.calendar_editor.modify_special_day_interval(result).done(function(events){
        for (var i in events[0]){
        calEvent[i] = events[0][i]
        }
        $.calendar_editor.fullCalendar('updateEvent', calEvent);
        });
        }).fail(function(result) {});
        */
}

ko.bindingHandlers.calendar_editor = {
    init:function(element, va, bindings, model, context) {
        var $elt = $(element);
        var result = ko.unwrap(va());
        $elt.data("inited", false);
        var is_tabbed = $(element).closest(".tabs").length > 0 ? true : false;
        is_tabbed && $elt.parent().show();
        
        var special_day_stack = [];

        var cal = new Calendar(element, {
            plugins: [daygridPlugin, timegridPlugin, listPlugin,
                interactionPlugin, resourceTimelinePlugin,
                resourceTimeGridPlugin
            ],
            initialView: "dayGridMonth",
            themeSystem: "standard",
            headerToolbar: {
                start: "prev,today,next",
                center: "title",
                end: "dayGridMonth,listWeek"
            },
            timeZone: "local",
            selectable: true,
            selectHelper: true,
            editable: true,
            buttonText: {
                today: _("frontend_calendar_today", "Today"),
                month: _("frontend_calendar_month_view", "M"),
                week: _("frontend_calendar_week_view", "W"),
                day: _("frontend_calendar_day_view", "D"),
                list: _("frontend_calendar_list_view", "L"),
                resourceTimelineWeek: "R"
            },
            buttonIcons:{
                prev: ' fa fa-caret-left',
                next: ' fa fa-caret-right'
            },
            events : function({start, end, timezone}, callback) {
                var inited = $elt.data("inited");
                if (!inited) {
                    callback([]);
                    return;
                }
                uly.api.start()
                    .follow("uly:data")
                    .follow("uly:specialdayinterval", {
                        "origin": ko.unwrap(ko.unwrap(va()).unique_id),
                        "path": "special_days_interval",
                        "filters": "(start <= '"+ end.toJSON()+"') and ((end >= '"+start.toJSON()+"') or start >= '" + start.toJSON() + "')",
                        "fields": ["start","end","id","title","closed"],
                        "embed": true
                    })
                    .follow("item")
                    .then(function(items) {
                        var events = items.map(function(ev) {
                            var new_ev = {
                                start: new moment(ev.start),
                                end: new moment(ev.end),
                                allDay: ev.closed
                            };
                            ev.start = new moment(ev.start).toISOString();
                            ev.end = new moment(ev.end).toISOString();
                            ev.allDay = ev.closed;
                            ev.color = "var(--{0})".format(
                                ev.closed ? "tomato" : "primary"
                            );
                            
                            return ev;
                        });
                        console.log("Calendar: Rendering events:", events);
                        callback(events);
                    }, function(error) {
                        callback([]);
                        console.error("Error fetching calendar events:", error);
                    });
            },
            // eventRender: function(event, element) {
            //     event.allDay 
            //         ? element.addClass("full-day bg-tomato").find(".fc-title").text(
            //             _("calendar_days_closed_title", "Closed day") +
            //                 (event.title ? " " + event.title : "") )
            //     : element.find(".fc-time").text(render_event_text(event));
            //     element.attr("title",
            //                 event.allDay 
            //                     ? _("calendar_days_closed_title", "Closed day") + (event.title ? " " + event.title : "") 
            //                     : render_event_text(event) + (event.title ? " " + event.title: ""));
            // },
            eventClick: function(info) {
                const event = info.event;
                console.log("Event click: ", info, "event:", event);
                $elt.trigger("action:edit_special_day", { unique_id: "SpecialDayInterval#"+event.id });
            },
            eventContent: function(eventInfo) {
                const event = eventInfo.event;
                return { "html": `
                <div title="{0}" style="text-overflow:ellipsis;max-width:100%;overflow:hidden;white-space:nowrap;">
                    <i class="fa {1}"></i>
                    <strong>{2}</strong>
                    <span>{0}</span>
                </div>
                `.format(event.title, event.extendedProps.model_icon, event.allDay? "" : moment(event.start).format("H:mm"))
                };
            },
            eventDrop : function(calEvent, jsEvent, view) {
                var evData = {
                    "start": calEvent.start.toDate(),
                    "end": calEvent.end.toDate(),
                    "closed": calEvent.allDay
                };
                uly.data.update(calEvent, evData);
            },
            eventResize : function(calEvent, jsEvent, view) {
                var evData = {
                    "start": calEvent.start.toDate(),
                    "end": calEvent.end.toDate(),
                    "closed": calEvent.allDay
                };
                uly.data.update(calEvent, evData);
            },
            dayClick: function(date, ev) {
                var calendar_id = ko.unwrap(ko.unwrap(va()).calendar_id);
                var tmp = {
                    "title":"",
                    "calendar_id": calendar_id,
                    "allDay":false,
                    "start":date,
                    "end":date,
                    "date":date
                };

                $(element).trigger("action:add_special_day", {
                    unique_id: "Calendar#"+calendar_id,
                    initial_data: {
                        "date": date,// && date.toDate(),
                        "allDay": false
                    }
                });
            }
        });

        
        $elt.closest(".modal").on("shown.bs.modal", function() {
            $elt.data("inited", true);
            cal.render();
        });

        var $tabs = $(element).parents(".tab-pane");
        var $links = $tabs.map(function(idx, tab) {
            var id = $(tab).attr("id");
            return $(tab).parent().parent().children("ul").find("li a[href='#"+id+"']")[0];
        });
        $links.on("shown.bs.tab", function() { 
            $elt.data("inited", true);
            cal.render();
         });

        uly.subscribe("entity.modified", function() {
            var inited = $(element).data("inited");
            if (inited) {
                cal.refetchEvents();
            }
        }, $(element));
        
        
    },
    update: function(element, va, bindings, model, context) {
        var events = ko.utils.unwrapObservable(va());
        var inited = $(element).data("inited");
        if (inited) {
            cal.refetchEvents();
        }
    }
};
    
